import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { AddRemoveInputs, FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectFundsRecCountrys } from "@redux";
import { ClientFundRecCountry } from "../elements/ClientFundRecCountry";

export const ClientFundsRecCountrys = ({
  control,
  unregister,
  totalFundsCountries,
  setTotalFundsCountries
}) => {
  const CFURC = useSelector(selectFundsRecCountrys);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-part-note">{trb(i18.Labels.IncomFrom)}</p>
      </FullWidthInputWrapper>
      {new Array(totalFundsCountries).fill(null).map((_, index) => (
        <ClientFundRecCountry control={control} countryIndex={index} key={CFURC[index]?.value} />
      ))}
      <AddRemoveInputs
        totalInputsAdded={totalFundsCountries}
        maxInputsAllowed={CFURC.length}
        onAdd={() => setTotalFundsCountries(prev => prev + 1)}
        onRemove={() => {
          unregister(`clientFundsRecCountrys.${totalFundsCountries - 1}`);
          setTotalFundsCountries(prev => prev - 1);
        }}
      />
    </StepperFormRow>
  );
};
